module.exports = __webpack_public_path__ + "img/1f988.08dd627.svg";